"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _reactIntl = require("react-intl");
var _reactStripeJs = require("@stripe/react-stripe-js");
var _Translated = _interopRequireDefault(require("../Translated"));
var _hooks = require("../../hooks");
var _api = require("../../api");
var _adapters = require("../../api/adapters");
var _AlertMessage = _interopRequireDefault(require("../AlertMessage"));
var _response = require("../../utils/response");
var _moment = require("../../utils/vendor/moment");
var _dompurify = require("../../utils/dompurify");
var _SubscriptionPlansRadioGroup = require("../SubscriptionPlansRadioGroup");
var _Button = require("../Button");
var _BillingAddress = require("../BillingAddress");
var _location = require("../../utils/location");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _styles.makeStyles)(theme => (0, _styles.createStyles)({
  header: {
    fontWeight: 'bold',
    marginBottom: 10
  },
  textSecondary: {
    fontSize: 18,
    marginTop: 0,
    marginBottom: 20
  },
  cardNumber: {
    marginBottom: '8px',
    padding: '16px',
    border: '1px solid #d2d2d2'
  },
  cardCvc: {
    width: '100%',
    padding: '16px',
    border: '1px solid #d2d2d2'
  },
  cardExpiry: {
    width: '100%',
    marginRight: '8px',
    padding: '16px',
    border: '1px solid #d2d2d2'
  },
  cards: {
    position: 'absolute',
    right: '20px',
    top: '60px'
  },
  cardImage: {
    width: '37px',
    marginLeft: 10
  },
  submitButton: {
    backgroundColor: '#5A873E',
    color: 'white',
    paddingLeft: 57,
    paddingRight: 57
  },
  main: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  mainLeft: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    },
    [theme.breakpoints.down('xs')]: {
      alignItems: 'flex-start'
    }
  },
  image: {
    width: '100%'
  },
  inboxBtn: {
    marginLeft: 20
  },
  mainRight: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '50%',
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  cardProcessing: {
    opacity: 0.5
  }
}));
const SubscriptionActivationForm = _ref => {
  let {
    config,
    maxWidth,
    onClose,
    hasPaymentSucceeded,
    onSubmit,
    onPlanChange,
    expiresAt,
    customer,
    disabled: passedIsDisabled = false,
    defaultSelectedPlan = null
  } = _ref;
  const {
    brandId,
    locale,
    isInclusivePrices
  } = (0, _hooks.useConfig)();
  const classes = useStyles();
  const [activeStep, setActiveStep] = (0, _react.useState)(0);
  const [fetchingSetupIntentError, setFetchingSetupIntentError] = (0, _react.useState)(null);
  const [cardError, setCardError] = (0, _react.useState)(null);
  const [requestInProgress, setRequestInProgress] = (0, _react.useState)(false);
  const [attachPaymentMethodError, setAttachPaymentMethodError] = (0, _react.useState)(null);
  const [countryCode, setCountryCode] = (0, _react.useState)('');
  const [zipCode, setZipCode] = (0, _react.useState)('');
  const [isZipCodeValid, setZipCodeValid] = (0, _react.useState)(true);
  const intl = (0, _reactIntl.useIntl)();
  const stripe = (0, _reactStripeJs.useStripe)();
  const elements = (0, _reactStripeJs.useElements)();
  (0, _react.useEffect)(() => {
    if (!customer) {
      return;
    }
    setCountryCode(customer.address?.country || '');
    setZipCode(customer.address?.postal_code || '');
  }, [customer]);
  const loading = requestInProgress;
  const isChangesDisabled = requestInProgress || !elements || !stripe || hasPaymentSucceeded;
  const isSubmitDisabled = passedIsDisabled || !isZipCodeValid || isChangesDisabled;
  const introPageHTML = _dompurify.dompurify.sanitize(config?.intro_page_html || '');
  const isAccountPage = (0, _location.getUrlParam)('_action') === 'plugin.recurrent_account';
  const shouldRenderIntroPage = !isAccountPage && !!config?.intro_page_active && activeStep === 0 && introPageHTML;
  const moment = (0, _moment.getLocalizedMoment)(locale);
  const descriptionHTML = _dompurify.dompurify.sanitize(config?.description.replace(/{date}/g, expiresAt ? moment.utc(expiresAt).format('LL') : ''));
  const handleNext = () => {
    setActiveStep(currentStep => currentStep + 1);
  };
  const handleSubmit = async e => {
    e.preventDefault();
    setCardError(null);
    setAttachPaymentMethodError(null);
    setRequestInProgress(true);
    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }
    const [setupIntentError, setupIntent] = await (0, _api.fetchSetupIntent)();
    setFetchingSetupIntentError(setupIntentError);
    if (setupIntentError) {
      return;
    }
    if (isInclusivePrices) {
      const customerId = customer?.id || setupIntent.customer;
      const customerAddress = (0, _adapters.getAdaptedCustomerAddress)(countryCode, zipCode);
      await (0, _api.updateCustomerAddress)(customerId, customerAddress, brandId);
    }
    const result = await stripe.confirmCardSetup(setupIntent.client_secret, {
      payment_method: {
        card: elements.getElement(_reactStripeJs.CardNumberElement)
      }
    });
    if (!result.error && result.setupIntent) {
      const [error, response] = await (0, _api.attachPaymentMethod)(result.setupIntent.payment_method, {
        default: true
      });
      if (!error && response) {
        await onSubmit(response);
      } else {
        setAttachPaymentMethodError(error);
      }
    } else {
      setCardError(result.error);
    }
    setRequestInProgress(false);
  };
  const renderConfigError = () => {
    return /*#__PURE__*/_react.default.createElement(_AlertMessage.default, null, /*#__PURE__*/_react.default.createElement(_Translated.default, {
      id: "something_went_wrong_please_contact_support"
    }));
  };
  const renderIntroStep = () => {
    return /*#__PURE__*/_react.default.createElement("form", null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.main
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.mainLeft
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: classes.textSecondary,
      dangerouslySetInnerHTML: {
        __html: introPageHTML
      }
    })))), /*#__PURE__*/_react.default.createElement(_core.Box, null, /*#__PURE__*/_react.default.createElement(_core.Button, {
      type: "submit",
      className: classes.submitButton,
      variant: "contained",
      onClick: handleNext
    }, /*#__PURE__*/_react.default.createElement(_Translated.default, {
      id: "next"
    })), /*#__PURE__*/_react.default.createElement(_Button.Button, {
      variant: _Button.BUTTON_VARIANT.LABEL,
      className: classes.inboxBtn,
      onClick: onClose
    }, /*#__PURE__*/_react.default.createElement(_Translated.default, {
      id: "inbox"
    }))));
  };
  const renderMainStep = () => {
    return /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: handleSubmit
    }, hasPaymentSucceeded && /*#__PURE__*/_react.default.createElement(_core.Box, {
      mb: 3
    }, /*#__PURE__*/_react.default.createElement(_AlertMessage.default, {
      variant: "filled",
      severity: "success"
    }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_Translated.default, {
      id: "subscription_activated"
    })))), /*#__PURE__*/_react.default.createElement(_core.Box, {
      mb: 5
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "h4",
      className: classes.header,
      component: "h1"
    }, config.title)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.singleStepContent
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.main
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.mainLeft
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: classes.textSecondary,
      dangerouslySetInnerHTML: {
        __html: descriptionHTML
      }
    })))))), /*#__PURE__*/_react.default.createElement(_core.Box, {
      mt: 2
    }, /*#__PURE__*/_react.default.createElement(_SubscriptionPlansRadioGroup.SubscriptionPlansRadioGroup, {
      defaultSelectedPlan: defaultSelectedPlan,
      onPlanChange: onPlanChange,
      maxWidth: maxWidth,
      disabled: isChangesDisabled
    }), (cardError || attachPaymentMethodError) && /*#__PURE__*/_react.default.createElement(_core.Box, {
      my: 2
    }, /*#__PURE__*/_react.default.createElement(_AlertMessage.default, {
      text: cardError?.message || (0, _response.getErrorMessage)(attachPaymentMethodError)
    })), fetchingSetupIntentError && /*#__PURE__*/_react.default.createElement(_core.Box, {
      my: 2
    }, /*#__PURE__*/_react.default.createElement(_AlertMessage.default, {
      text: (0, _response.getErrorMessage)(fetchingSetupIntentError)
    })), isInclusivePrices && /*#__PURE__*/_react.default.createElement(_BillingAddress.BillingAddress, {
      countryCode: countryCode,
      onCountryCodeChange: e => {
        setCountryCode(e.target.value);
      },
      zipCode: zipCode,
      onZipCodeChange: e => {
        setZipCode(e.target.value);
      },
      zipCodeValid: isZipCodeValid,
      setZipCodeValid: setZipCodeValid,
      disabled: isChangesDisabled
    }), stripe && elements && /*#__PURE__*/_react.default.createElement(_core.Box, {
      py: 2,
      position: "relative"
    }, loading && /*#__PURE__*/_react.default.createElement(_core.Box, {
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      py: 2,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }, /*#__PURE__*/_react.default.createElement(_core.CircularProgress, {
      size: 100
    })), /*#__PURE__*/_react.default.createElement(_core.Box, {
      className: loading && classes.cardProcessing
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "subtitle1"
    }, /*#__PURE__*/_react.default.createElement(_Translated.default, {
      id: "credit_card_number"
    })), /*#__PURE__*/_react.default.createElement(_reactStripeJs.CardNumberElement, {
      options: {
        showIcon: true,
        disabled: loading,
        classes: {
          base: classes.cardNumber
        }
      }
    })), /*#__PURE__*/_react.default.createElement(_core.Box, {
      display: "flex",
      className: loading && classes.cardProcessing
    }, /*#__PURE__*/_react.default.createElement(_core.Box, {
      width: "100%"
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "subtitle1"
    }, /*#__PURE__*/_react.default.createElement(_Translated.default, {
      id: "card_expiration"
    })), /*#__PURE__*/_react.default.createElement(_reactStripeJs.CardExpiryElement, {
      options: {
        placeholder: intl.formatMessage({
          id: 'card_expiry_placeholder'
        }),
        disabled: loading,
        classes: {
          base: classes.cardExpiry
        }
      }
    })), /*#__PURE__*/_react.default.createElement(_core.Box, {
      width: "100%",
      ml: 1
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "subtitle1"
    }, /*#__PURE__*/_react.default.createElement(_Translated.default, {
      id: "card_cvc"
    })), /*#__PURE__*/_react.default.createElement(_reactStripeJs.CardCvcElement, {
      options: {
        disabled: loading,
        classes: {
          base: classes.cardCvc
        }
      }
    })))), /*#__PURE__*/_react.default.createElement(_core.Box, null, /*#__PURE__*/_react.default.createElement(_core.Button, {
      type: "submit",
      color: "primary",
      variant: "contained",
      className: classes.submitButton,
      disabled: isSubmitDisabled
    }, /*#__PURE__*/_react.default.createElement(_Translated.default, {
      id: "activate_new_subscription"
    })), /*#__PURE__*/_react.default.createElement(_Button.Button, {
      variant: _Button.BUTTON_VARIANT.LABEL,
      className: classes.inboxBtn,
      onClick: onClose,
      disabled: isChangesDisabled
    }, /*#__PURE__*/_react.default.createElement(_Translated.default, {
      id: "inbox"
    })))));
  };
  const renderSteps = () => {
    if (!config) {
      return renderConfigError();
    }
    if (shouldRenderIntroPage) {
      return renderIntroStep();
    }
    return renderMainStep();
  };
  return renderSteps();
};
var _default = exports.default = SubscriptionActivationForm;